import {useState, JSX, useRef, RefObject} from 'react';
import {
    useRecordContext,
    useNotify,
} from 'react-admin';
import {
    RichTextEditor,
    type RichTextEditorRef,
} from "mui-tiptap";
import {
    Grid,
    Box,
    TextField,
} from '@mui/material';
import './styles/cms-editor.scss';
import { useFormContext } from "react-hook-form";
import DOMPurify from 'dompurify';
import EditorControls from "./EditorControls";
import useExtensions from "./extension-hooks";
import {Extensions} from "@tiptap/core";

export const CmsEditor: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const formKey: string = props?.formKey ?? 'content';
    const record: any = useRecordContext();
    const { setValue, getValues } = useFormContext();
    const [contentDraft, setContentDraft] = useState<string>(record?.[formKey] ?? '');
    const rteRef: RefObject<any> = useRef(null);
    const extensions: Extensions = useExtensions();

    const handleOnContentChange = (value: any) => {
        let text: string = rteRef.current.editor.getHTML();
        text = DOMPurify.sanitize(text);

        setContentDraft(text);
        setValue(formKey, text, { shouldDirty: true })
    }

    return (
        <Box className="cms-editor" >
            <RichTextEditor
                ref={rteRef}
                extensions={ extensions } // Or any Tiptap extensions you wish!
                content={ contentDraft } // Initial content for the editor
                renderControls={ EditorControls }
                onUpdate={ handleOnContentChange }
                className="editor__container"
            />
        </Box>
    );
}